module.exports = __webpack_public_path__ + "img/2.d5186d12.jpg";